"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("./models");
var ContentConstants = /** @class */ (function () {
    function ContentConstants() {
    }
    // MISC
    ContentConstants.COLUMNPICKER_TITLE = 'Columns';
    ContentConstants.EMPTY_PLACEHOLDER = '--';
    ContentConstants.ERROR = 'Error';
    // SEARCH
    ContentConstants.SEARCH_NO_RESULTS_MESSAGE = 'There are no results for this search.';
    ContentConstants.TOOLTIP_DIMENSION_TYPE_TEXT = 'An Index is a grouping of items, mostly unique to a client, ' +
        'that measures non-engagement concepts – i.e., Engaging Leader, Agility';
    ContentConstants.TOOLTIP_DIMENSION_ISSCORED_TEXT = 'Scored dimension – calculates the average favorability of the items within the dimension/category';
    // BUTTONS
    ContentConstants.BUTTONS_CREATE_CUSTOM_QUESTION = 'Create Custom Question';
    ContentConstants.BUTTONS_CREATE_QUESTION = 'Create Question';
    ContentConstants.BUTTONS_BACK_TO_QUESTIONS = 'Back To Questions';
    ContentConstants.BUTTONS_UPDATE_QUESTION = 'Update Question';
    ContentConstants.DIMENSION_NEW_CUSTOM_DIMENSION = 'Create Dimension';
    // QUESTIONS TABLE
    ContentConstants.SURVEYQUESTIONS_THRESHOLD_EXCEEDED = 'You have exceeded the ' +
        'maximum number of {threshold} survey questions allowed. You will not be allowed to ' +
        'schedule your survey until you remove some of the questions.';
    ContentConstants.DEMOGRAPHICQUESTIONS_THRESHOLD_EXCEEDED = 'You have exceeded the ' +
        'maximum number of {threshold} demographic questions allowed. You will not be allowed to ' +
        'schedule your survey until you remove some of the questions.';
    ContentConstants.MISSING_BENCHMARK_TOOLTIP_TITLE_TEXT = 'Missing Chosen Benchmarks';
    ContentConstants.MISSING_BENCHMARK_TOOLTIP_REMINDER_TEXT = 'To change your enabled benchmarks, go back to the previous step.';
    // Warning messages
    ContentConstants.WARNING_CUSTOM_DIMENSION_HEADLINE = "Your previously selected questions will be deselected";
    ContentConstants.WARNING_CUSTOM_DIMENSION_BODY = 'Your selected questions from the previously used response scale will be deselected if you continue. ' +
        'A dimension can only include questions from one response scale. Are you sure you wish to continue?';
    // ERROR MESSAGES
    ContentConstants.ERROR_MISSING_TRANSLATION = 'You are missing translation text';
    ContentConstants.MISSING_LANGUAGES_TOOLTIP_TITLE_TEXT = 'Missing Chosen languages';
    ContentConstants.MISSING_LANGUAGES_TOOLTIP_REMINDER_TEXT = 'To change your enabled languages, go back to the previous step.';
    ContentConstants.SURVEYQUESTIONLIST_MISSING_TRANSLATIONS = 'You are missing translation(s)';
    ContentConstants.MAPPED_ATTRIBUTE_TOOLTIP_TITLE = 'Mapped Attribute';
    ContentConstants.MAPPED_ATTRIBUTE_TOOLTIP_BODY = 'You will be able to filter and segment your ' +
        'data based on responses to this question. This is the name of the attribute you will use for ' +
        'filtering and segmenting your data.';
    // DIMENSION TABLE
    ContentConstants.DIMENSION_LIST_NODIMENSION = 'No Dimensions';
    ContentConstants.DIMENSION_LIST_DEMOGRAPHIC_DIMENSION = 'Demographic';
    ContentConstants.DIMENSION_FILTER_ALL_DIMENSIONS_INDICES = 'All Dimensions/Indices';
    ContentConstants.DIMENSION_FILTER_KINCENTRIC_LIBRARY_DIMENSIONS = 'Kincentric Dimensions';
    ContentConstants.DIMENSION_FILTER_KINCENTRIC_LIBRARY_INDICES = 'Kincentric Indices';
    ContentConstants.DIMENSION_FILTER_CLIENT_LIBRARY_DIMENSIONS = 'My Company Dimensions';
    ContentConstants.DIMENSION_FILTER_CLIENT_LIBRARY_INDICES = 'My Company Indices';
    ContentConstants.CUSTOM_DIMENSION_SELECT_DISPLAY_TEXT = 'Select';
    ContentConstants.DIMENSION_CREATE_CUSTOM_DIMENSION = 'Create Dimension';
    ContentConstants.DIMENSION_EDIT_CUSTOM_DIMENSION = 'Save';
    ContentConstants.DIMENSION_SAVE_DRAFT_CUSTOM_DIMENSION = 'Save As Draft';
    ContentConstants.DIMENSION_SAVE_PUBLIC_CUSTOM_DIMENSION = 'Save & Make Dimension Public';
    ContentConstants.DIMENSION_CANCEL_CUSTOM_DIMENSION = 'Cancel';
    ContentConstants.DIMENSION_TABLE_DROPDOWN_COPY_CUSTOM = 'Create a Copy';
    ContentConstants.DIMENSION_TABLE_DROPDOWN_COPY = 'Copy';
    ContentConstants.DIMENSION_TABLE_DROPDOWN_EDIT = 'Edit';
    ContentConstants.DIMENSION_TABLE_DROPDOWN_DELETE = 'Delete';
    // Question Filters
    ContentConstants.FILTER_BENCHMARKS = 'Benchmarks';
    ContentConstants.FILTER_LANGUAGES = 'Languages';
    ContentConstants.FILTER_QUESTION_TEMPLATES = 'Question Templates';
    ContentConstants.FILTER_RESPONSE_OPTION_GROUPS = 'Response Option Groups';
    ContentConstants.FILTER_TAGS = 'Tags';
    // CUSTOM QUESTION
    ContentConstants.CUSTOM_QUESTION_RECOMMENDED_TEXT = 'Recommended character limit:';
    ContentConstants.MAPPED_ATTRIBUTE_SELECTOR_TEXT = 'Select An Attribute';
    ContentConstants.CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_HEADER = 'Mapped Attribute';
    ContentConstants.CUSTOM_DEMOGRAPHIC_QUESTION_MAPPED_ATTRIBUTE_MESSAGE = 'Every demographic question ' +
        'either from the library or custom, must have a filter/segment attribute mapped to it. Please select at ' +
        'attribute for your question below. You can only select attributes that have not been selected yet. ' +
        '<strong>Note: mapped attributes that are currently in use or are in another custom demographic question ' +
        'will be disabled in the dropdown and not selectable.</strong>';
    ContentConstants.CUSTOM_QUESTION_BENCHMARKS_TEXT = "Custom questions used in survey won't display benchmarks data while reporting";
    ContentConstants.CUSTOM_QUESTION_DIMENSIONS_DISPLAY_TEXT = 'Dimensions';
    ContentConstants.CUSTOM_QUESTION_INDICES_DISPLAY_TEXT = 'Indices';
    ContentConstants.CUSTOM_QUESTION_TAGS_DISPLAY_TEXT = 'Tags';
    ContentConstants.CUSTOM_QUESTION_TEMPLATES_DISPLAY_TEXT = 'Templates';
    // MAPPED ATTRIBUTES
    ContentConstants.MAPPED_ATTRIBUTE_IN_USE_BY_CUSTOM_TOOLTIP_BODY = 'Attribute already in use. ' +
        "This attribute is already in use by one of your selected custom demographic questions. If you'd " +
        "like to select this question, please deselect the custom demographic question that's using " +
        'this attribute, then select this question.';
    ContentConstants.MAPPED_ATTRIBUTE_IN_USE_BY_LIBRARY_TOOLTIP_BODY = 'Attribute already in use. ' +
        "This attribute is already in use by one of your selected library demographic questions.  If you'd " +
        "like to select this question, please deselect the library demographic question that's using this " +
        'attribute, then select this question.';
    // TRANSLATIONS
    ContentConstants.TRANSLATIONS_QUESTION = 'question';
    ContentConstants.TRANSLATIONS_DIMENSION = 'dimension';
    ContentConstants.TRANSLATIONS_DEFAULT_TRANSLATION_REQUIRED = 'You must enter a {property} before you can translate it.';
    ContentConstants.TRANSLATIONS_RESPONSEOPTION = 'response option';
    // CUSTOM RESPONSE OPTIONS
    ContentConstants.CUSTOM_RESPONSEOPTION_LABEL_PLACEHOLDER = 'Name of label';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_LABEL = 'Response Label';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_TRANSLATIONS = 'Translations';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_VALUE = 'Value';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TITLE = 'Response Option - Value';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TEXT = 'This is the value that will be entered in the database for your response option. ' +
        'While you can change the values, we recommend you keep the default values we provide.';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP = 'Follow-Up';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TITLE = 'Response Option - Follow-Up';
    ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TEXT = 'A follow up is a text box following the response option to gather additional information from that participant. ' +
        'It is recommended that this be the last response option for that question and can only be included on one response option.';
    ContentConstants.CUSTOM_RESPONSEOPTION_ADD_TEXT = 'Add response';
    ContentConstants.CUSTOM_RESPONSEOPTION_ERROR_LABEL_EMPTY = 'You must enter a label name.';
    ContentConstants.CUSTOM_RESPONSEOPTION_ERROR_LABEL_LENGTH_EXCEEDED = 'You have exceeded the max character limit of 150 for this input or translation. Please delete the necessary characters.';
    ContentConstants.CUSTOM_RESPONSEOPTION_ERROR_VALUE_EMPTY = 'You must enter a value.';
    ContentConstants.CUSTOM_RESPONSEOPTION_ERROR_VALUE_DUPLICATE = 'You cannot have duplicate values.';
    ContentConstants.RESPONSE_OPTION_GROUP_OPENENDED = 'Open-Ended';
    ContentConstants.RESPONSE_OPTION_GROUP_OPENEDED_DESCRIPTION = 'Supports comments up to multiple lines of text, encouraging respondents to provide a longer response.';
    ContentConstants.RESPONSE_OPTION_GROUP_TEXTBOX = 'Text Box';
    ContentConstants.RESPONSE_OPTION_GROUP_TEXTBOX_DESCRIPTION = 'Supports comments up to a single line of text, encouraging respondents to provide a short response.';
    ContentConstants.CUSTOM_RESPONSEOPTION_MISSING = 'You must choose a response option.';
    ContentConstants.CUSTOM_QUESTION_TEXT_MISSING = 'You must enter question text.';
    ContentConstants.CUSTOM_RESPONSEOPTION_NA_OPTION_TEXT = 'Add N/A as additional option to the scale';
    ContentConstants.RESPONSE_OPTION_GROUP_MULTIPLE_RESPONSES = 'Multiple Responses';
    ContentConstants.RESPONSE_OPTION_GROUP_TAB_SINGLE_RESPONSE = 'For questions that only require one answer.';
    ContentConstants.RESPONSE_OPTION_GROUP_TAB_MULTIPLE_RESPONSE = 'For questions that could require more than one answer.';
    ContentConstants.RESPONSE_OPTION_GROUP_TAB_WARNING_HEADLINE = 'Data will be deleted.';
    ContentConstants.RESPONSE_OPTION_GROUP_TAB_WARNING_BODY = "Your response labels will be deleted by navigating away from the multiple answer section to the single answer section. This is\n\tbecause can only save one type of answer response.";
    // SECTION HEADERS
    ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_ADD = 'Add A Question';
    ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_CHOOSE_RESPONSEOPTION = 'Choose A Response Option';
    ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_CREATE_RESPONSEOPTION = 'Create A Response Option';
    // SUB-SECTION HEADERS
    ContentConstants.SUBSECTIONHEADERS_QUESTIONTEXT = 'Question Text';
    ContentConstants.SUBSECTIONHEADERS_QUESTIONCODE = 'Question Code';
    ContentConstants.SUBSECTIONHEADERS_QUESTIONTRANSLATIONS = 'Question Translations';
    ContentConstants.SUBSECTIONHEADERS_DIMENSIONS = 'Dimensions';
    ContentConstants.SUBSECTIONHEADERS_INDICES = 'Indices';
    ContentConstants.SUBSECTIONHEADERS_TAGS = 'Tags';
    ContentConstants.SUBSECTIONHEADERS_QUESTION_TEMPLATES = 'Question Templates';
    ContentConstants.SUBSECTIONHEADERS_BENCHMARKS = 'Benchmarks';
    ContentConstants.SUBSECTIONHEADERS_RESPONSE_OPTION_NAME = 'Response Option Name';
    // INPUT PLACEHOLDERS
    ContentConstants.INPUT_PLACEHOLDER_ENTER_QUESTION_TEXT = 'Enter your question text here';
    ContentConstants.INPUT_PLACEHOLDER_SEARCH_DIMENSIONS = 'Search Dimensions';
    ContentConstants.INPUT_PLACEHOLDER_SEARCH_INDICES = 'Search Indices';
    ContentConstants.INPUT_PLACEHOLDER_SEARCH_TAGS = 'Search Tags';
    ContentConstants.INPUT_PLACEHOLDER_SEARCH_TEMPLATES = 'Search Templates';
    ContentConstants.SECTIONHEADERS_CUSTOM_DIMENSION_NAME_AND_TRANSLATIONS = 'Dimension Info';
    ContentConstants.SECTIONHEADERS_CUSTOM_DIMENSION_QUESTIONS = 'Add Questions';
    // SECTION DESCRIPTION BLOCKS
    ContentConstants.SECTION_DESCRIPTION_DIMENSION_QUESTIONS = 'A dimension can only include questions' +
        ' from one Response Scale. Select a Response Scale for Questions you would like to add to this dimension.';
    // SUB_SECTION HEADERS
    ContentConstants.SUBSECTIONHEADERS_DIMENSION_NAME = 'Dimension Name';
    ContentConstants.SUBSECTIONHEADERS_DIMENSION_TYPE = 'Type';
    ContentConstants.SUBSECTIONHEADERS_DIMENSION_TRANSLATIONS = 'Add Translations';
    ContentConstants.SUBSECTIONHEADERS_DIMENSION_ISSCORED = 'Is Scored';
    // INPUT PLACEHOLDERS
    ContentConstants.INPUT_PLACEHOLDER_DIMENSION_NAME = 'Dimension Name';
    // INSTRUCTIONAL TEXT
    ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_CHOOSE_RESPONSEOPTION = 'Your selection will be ' +
        'the response option for your custom survey question. Make sure your choice makes ' +
        'sense with the above question text.';
    ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_RESPONSEOPTION_CHANGE_TYPE = "If you choose Open-Ended or a scale response, you can't change to the other after creating the question.";
    ContentConstants.INSTRUCTIONALTEXT_CUSTOMQUESTION_CREATE_RESPONSEOPTION = 'The created response option will be formatted as a series of radio buttons. ' +
        'A newly added option will be added as a radio button at the bottom of the series. ' +
        'If you have additional languages enabled, you need to add the translations for each option.';
    ContentConstants.ResponseOptions = [
        { displayText: 'Brand', displayOrder: 1 },
        { displayText: 'Career & Development', displayOrder: 2 },
        { displayText: 'Collaboration', displayOrder: 3 },
        { displayText: 'Customer Focus', displayOrder: 4 },
        { displayText: 'Decision Making ', displayOrder: 5 },
        { displayText: 'Diversity & Inclusion ', displayOrder: 6 },
        { displayText: 'Empowerment / Autonomy', displayOrder: 7 },
        { displayText: 'Enabling Infrastructure', displayOrder: 8 },
        { displayText: 'Manager  ', displayOrder: 9 },
        { displayText: 'Performance Management', displayOrder: 10 },
        { displayText: 'Rewards & Recognition ', displayOrder: 11 },
        { displayText: 'Senior Leadership ', displayOrder: 12 },
        { displayText: 'Talent & Staffing', displayOrder: 13 },
        { displayText: 'Work Tasks', displayOrder: 14 },
        { displayText: 'Work / Life Balance', displayOrder: 15 },
    ];
    ContentConstants.TranslationColumns = [
        {
            columnKey: 'cultureCode',
            label: 'Culture Code',
            type: 'typeahead',
            editable: true,
            placeholder: 'Culture Code',
            minWidth: '130px',
            remote: false,
            duplicatedMessage: 'Duplicate Culture Code',
            invalidMessage: 'Invalid Culture Code',
            validateDefault: true,
            yesIndicator: true,
            updateRelatedColumn: true,
            updateRelatedColumnKey: 'cultureName',
            maxLength: 10,
        },
        {
            columnKey: 'text',
            label: 'TRANSLATION TEXT',
            type: 'textarea',
            editable: true,
            placeholder: 'Translation text',
            requiredMessage: 'Missing translations for language $cultureCode',
        },
        {
            columnKey: 'cultureName',
            label: 'language',
            editable: false,
        },
        {
            columnKey: 'modifiedOn',
            label: 'UPDATED',
            editable: false,
            dataType: 'date',
            minWidth: '130px',
            replaceButton: true,
        },
    ];
    ContentConstants.SampleQuestions = [
        {
            questionId: 201,
            code: 'AA0001',
            dimensionNames: [],
            responseOptionGroup: 'Comment Topic Area',
            tagNames: ['Comment Coding'],
            templateNames: ['Exit'],
            attributeName: 1,
            responseOptions: ContentConstants.ResponseOptions,
            questionVariations: [
                {
                    questionVariationId: 1,
                    text: 'alt 1',
                    code: 'EN0001-01',
                    sourceType: models_1.SourceType.KincentricLibrary,
                    isDefault: false,
                    languageCount: 1,
                    languages: [],
                    publicationStatus: 2,
                },
                {
                    questionVariationId: 1,
                    text: 'This is Alt version for a Kincentric survey question with response option - 05 Feb',
                    code: 'EN0001-02',
                    sourceType: models_1.SourceType.KincentricLibrary,
                    isDefault: false,
                    languageCount: 1,
                    languages: [],
                    publicationStatus: 2,
                },
            ],
            questionType: models_1.QuestionType.Scale,
            text: 'Please select the single dimension topic area that best represents the comment you made: ',
            questionVariationId: 15,
            languageCount: 4,
            languages: ['en-US', 'en-CA', 'cs-CZ', 'fr-FR'],
            benchmarkIds: [],
            showVariations: true,
            alternateVersions: 1,
            sourceType: models_1.SourceType.KincentricLibrary,
            isDemographic: true,
        },
        {
            questionId: 202,
            code: 'BB0001',
            dimensionNames: ['Engagement'],
            responseOptionGroup: 'Comment Topic Area',
            tagNames: ['Comment Coding'],
            templateNames: ['Exit'],
            attributeName: 1,
            responseOptions: ContentConstants.ResponseOptions,
            questionVariations: [],
            text: 'Please select the single dimension topic area that best represents the comment you made: - two ',
            questionVariationId: 15,
            languageCount: 4,
            languages: ['en-US', 'en-CA', 'cs-CZ', 'fr-FR'],
            benchmarkIds: [],
            showVariations: false,
            alternateVersions: 1,
            sourceType: models_1.SourceType.KincentricLibrary,
            questionType: models_1.QuestionType.Scale,
            isDemographic: true,
        },
        {
            questionId: 203,
            code: 'CC0001',
            dimensionNames: ['Brand'],
            responseOptionGroup: 'Comment Topic Area',
            tagNames: ['Comment Coding'],
            templateNames: ['Exit'],
            attributeName: 1,
            responseOptions: ContentConstants.ResponseOptions,
            questionVariations: [],
            text: 'Please select the single dimension topic area that best represents the comment you made: - three ',
            questionVariationId: 15,
            languageCount: 4,
            languages: ['en-US', 'en-CA', 'cs-CZ', 'fr-FR'],
            benchmarkIds: [],
            showVariations: false,
            alternateVersions: 1,
            sourceType: models_1.SourceType.KincentricLibrary,
            questionType: models_1.QuestionType.Scale,
            isDemographic: true,
        },
    ];
    return ContentConstants;
}());
exports.default = ContentConstants;
